import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const updateAppVisibilityTE = <E = CF.API.ApiError>(
  { userId, appId, visibility }: { userId: string; appId: string; visibility: CF.API.Visibility },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Apps.ListAppsResponse> =>
  fetchTE<CF.API.Apps.ListAppsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/apps`,
      method: 'PATCH',
      body: {
        apps: [
          {
            id: appId,
            visibility,
          },
        ],
        action: 'overwrite',
      },
    },
    onRejected,
  );
